import Service from '../../Services/Service';

const AboutAPI = {
    getAboutAll(lang){
        return Service.get(`/about/get_about_all?language=${lang}`);
    },
    getAboutById(id,lang){
        return Service.get(`/about/get_about_by_id/${id}?language=${lang}`);
    },
    //all about menu
    getAboutAllMenu(branch_id,lang){
        return Service.get(`/site/about_by_branch?branch_id=${branch_id}&lang=${lang}`)
    },
    getAboutNewsByBranch(id,lang){
        return Service.get(`/about/news_by_branch?branch_id=${id}&lang=${lang}`);
    },
    getAboutNewsByPage(id,page){
        let p = page ? page:1;
        return Service.get(`/about/news_by_branch?branch_id=${id}&page=${p}`);
    },
    getAboutNewsById(id, lang){
        return Service.get(`/about/get_news_by_id/${id}?lang=${lang}`);
    }
}
export default AboutAPI
